import React from "react";
import styles from "../stylesER.module.scss";

export const BuildingCommissionModal = ({
  isOpen,
  monthIndex,
  mesesCompletos,
  comisiones,
  getMoneda,
  formatCurrency,
  onClose,
}) => {
  if (!isOpen || monthIndex === null) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3>Detalle comisión edificios - {mesesCompletos[monthIndex]}</h3>
        <table className={styles.modalTable}>
          <thead>
            <tr>
              <th className={styles.buildingFacturaHeader}>Factura</th>
              <th className={styles.buildingClienteHeader}>Cliente</th>
              <th className={styles.buildingComisionHeader}>Comisión {getMoneda()}</th>
            </tr>
          </thead>
          <tbody>
            {comisiones.map((comision, i) => (
              <tr key={i}>
                <td className={styles.buildingFacturaData}>{comision.facturanumero}</td>
                <td className={styles.buildingClienteData}>{comision.cliente}</td>
                <td className={styles.buildingComisionData}>{formatCurrency(comision.totalComision)}</td>
              </tr>
            ))}
            {comisiones.length > 0 && (
              <tr className={styles.modalTotal}>
                <td colSpan="2">
                  <strong>Total</strong>
                </td>
                <td className={styles.buildingComisionData}>
                  <strong>{formatCurrency(comisiones.reduce((sum, curr) => sum + curr.totalComision, 0))}</strong>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
